import { Component, inject } from '@angular/core';
import { AttachmentDialogComponent } from 'src/app/shared/components/attachment-dialog/attachment-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatFormField, MatLabel, MatInput, MatError } from '@angular/material/input';

@Component({
  selector: 'app-attachment',
  standalone: true,
  templateUrl: './attachment.component.html',
  styleUrls: ['./attachment.component.scss'],
  imports: [MatFormField, ReactiveFormsModule, MatLabel, MatInput, MatError],
})
export class AttachmentComponent1 {
  dialog = inject(MatDialog);

  field: any;
  group: UntypedFormGroup;
  filename = [];
  fileMerge = [];
  lastindex: number;
  key: number;
  // allowedTypes = '.doc,docx,.xls,xlsx,.pdf,.jpg,.jpeg,.msg,.png';
  // uploadType = 'single';
  requiredBool;
  OutputFileList: any;

  openDialog() {
    console.log(AttachmentDialogComponent);
    const dialogRef = this.dialog.open(AttachmentDialogComponent, {
      width: '500px',
      data: {
        allowedfileType: this.field.allowedTypes,
        uploadType: this.field.uploadType,
        fileNameValidation: this.field.validations.find((val) => {
          return val['name'] == 'pattern';
        }),
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        console.log(result);

        this.group.get(this.field.name).setValue(result[0]?.name);

        console.log('-------line 42------------, ', result);
        this.onFileSelected(result);

        console.log(this.group);
      }
    });
  }

  onFileSelected(filesArray) {
    const files = filesArray;
    this.filename = [];
    this.fileMerge = [];
    const lastChunksize = 0;
    // let chunkSize = 524288*10;
    const chunkSize = 5242880;
    // let chunkSize       = 524288; //maximum 512 = 524,288, 256 = 262,144 B
    this.lastindex = files.length;
    this.key = 1;

    for (const file of files) {
      this.filename.push(file.name);
      if (this.field.uploadType == 'single' && this.filename.length > 0) {
        this.fileMerge.splice(0, this.fileMerge.length);
      }
      this.readFile(file, lastChunksize, this.myCallback.bind(this), chunkSize);
    }
    const fileMerge = this.fileMerge;
    const fileName = this.filename.join();
    this.OutputFileList = { fileMerge, fileName };
    this.group['uploadedFile'] = this.OutputFileList;
  }

  myCallback(file, lastChunksize, result, chunkSize) {
    lastChunksize = lastChunksize + chunkSize;
    if (result) {
      this.readFile(file, lastChunksize, this.myCallback.bind(this), chunkSize);
    } else {
      ///end recursion
    }
  }

  readFile(file, lastChunksize: number, callback, chunkSize) {
    const fileBlob = file.slice(lastChunksize, lastChunksize + chunkSize);
    if (fileBlob.size != 0) {
      const fileReader = new FileReader();
      fileReader.onloadend = (_result) => {
        this.fileMerge.push(file);
        return callback(file, lastChunksize, fileReader.result, chunkSize);
      };
      fileReader.readAsText(fileBlob);
    } else {
      return callback(file, lastChunksize, false);
    }
  }
}
